// Numeric breakpoint values (default export for arithmetic/comparisons)
const breakpoints = {
  xs: 576,
  sm: 768,
  md: 1024,
  lg: 1200,
  xl: 1440,
  "2xl": 1600,
  "3xl": 1720,
  "4xl": 1880,
} as const;

// String breakpoints with px units (for Chakra v3 theme config)
// Note: Chakra v3 requires 'base' as the smallest breakpoint (0px, mobile-first)
export const breakpointsTheme = {
  base: "0px", // Required by Chakra v3 as the smallest breakpoint
  xs: `${breakpoints.xs}px`,
  sm: `${breakpoints.sm}px`,
  md: `${breakpoints.md}px`,
  lg: `${breakpoints.lg}px`,
  xl: `${breakpoints.xl}px`,
  "2xl": `${breakpoints["2xl"]}px`,
  "3xl": `${breakpoints["3xl"]}px`,
  "4xl": `${breakpoints["4xl"]}px`,
} as const;

export default breakpoints;
